<template>
  <b-row class="collar-leash-select-row mx-auto">
    <CollarLeashGroup
      v-for="group in groups"
      :key="group.id"
      :group="group"
      :product-style-code="productStyleCode"
      @submit="redirectToStyle"
    />
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import getImage from '../../mixins/getImage';
import CollarLeashGroup from './CollarLeashGroup';
import { CollarLeashProductGroupMixins } from '@/mixins/components/productGroup';

export default {
  name: 'CollarLeashSelect',
  components: { CollarLeashGroup },
  mixins: [getImage, CollarLeashProductGroupMixins],
  props: {
    groups: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState({
      collarProductStyle: (state) => state.collarProduct.style,
      leashProductStyle: (state) => state.leashProduct.style,
    }),
    productStyleCode() {
      return this.isCollarGroup() ? this.collarProductStyle?.code : this.leashProductStyle?.code;
    },
  },
};
</script>

<style lang="scss" scoped>
.collar-leash-select-row {
  max-width: 1024px;
}
</style>
